import React, { useState, useEffect, useRef } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../components/MaterialButton";
import colors from "../../assest/theme/base/colors";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Typography,
  DialogTitle,
} from "@mui/material";
import DynamicTableProps from "../Utils/DynamicTableProps";
import ConfirmDialog from "../Utils/ConfirmDialog";
import MessagePopup from "../Utils/MessagePopup";
import { BASE_URL, FetchDataGet, deleteItem } from "../../BaseUrl";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import { getbulkuploadlist, deletebulkdata, bulkCandidatesearch } from "./mutation";
import LoadingSpinner from "../loader/loadercomp";
import AccessComponent from "../Utils/AccessComponent";

function BulkuploadCandidate() {
  const [open, setOpen] = useState(false);
  const [openfileupload, setOpenFileUpload] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => { },
  });
  const [Loader, setLoader] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [uploadlists, setuploadlist] = useState([]);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const allowedTypes = [
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const allowedExtensions = ["csv", "xls", "xlsx"];

  // Create a reference for the file input element
  const fileInputRef = useRef(null);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const columns = [
    { label: "check Box", field: "checkBox", width: "50px" },
    { label: "Job Title", field: "jobTitle", width: "100px" },
    {
      label: "Date of application",
      field: "dateOfApplication",
      width: "100px",
    },
    { label: "Name", field: "name", width: "100px" },
    { label: "Phone Number", field: "phone", width: "130px" },
    { label: "Date of Birth", field: "dob", width: "100px" },
    { label: "Gender", field: "gender", width: "100px" },
    { label: "Total Experience", field: "totalExperience", width: "100px" },
    { label: "Current Location", field: "currentLocation", width: "100px" },
    {
      label: "Preferred Locations",
      field: "preferredLocations",
      width: "100px",
    },
    { label: "Graduation degree", field: "graduationDegree", width: "100px" },
    { label: "UG Specialization", field: "ugSpecialization", width: "160px" },
    { label: "UG Graduation year", field: "ugYear", width: "100px" },
    {
      label: "Post graduation degree",
      field: "pgDegree",
      width: "100px",
    },
    { label: "PG specialization", field: "pgSpecialization", width: "100px" },
    { label: "PG graduation year", field: "pgYear", width: "100px" },
  ];

  const validClientData = Array.isArray(uploadlists) ? uploadlists : [];

  const sortedData = [...validClientData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validClientData; // default to descending
    }
  });

  const onView = () => {
    setOpen(true);
  };

  const onEdit = () => {
    setOpen(true);
  };
  useEffect(() => {
    setPage(1);
  }, [searchdata]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchuploadlist();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [page, pageSize, searchdata]);

  const fetchuploadlist = async () => {
    setLoader(true);
    try {
      if (searchdata && searchdata.length > 2) {
        const response = await FetchDataGet(bulkCandidatesearch, { search: searchdata, page, pageSize });
        if (response.searchCandidates?.success == true) {
          setuploadlist(response.searchCandidates.data);
          setTotalCount(response.searchCandidates.totalCount);
        } else {
          console.error("error fetching search data");
        }
      } else {
        const response = await FetchDataGet(getbulkuploadlist, { page, pageSize });
        if (response.getAllCandidates?.success == true) {
          setuploadlist(response.getAllCandidates.data);
          setTotalCount(response.getAllCandidates.totalCount);
        } else {
          console.error("error fetching data");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const onDelete = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteRole(id),
    });
  };

  // Delete API call
  const deleteRole = async (id) => {
    handleCloseDialog();
  };

  // Open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  const handleFileChange = () => {
    const selectedFile = fileInputRef.current.files[0];
    setError("");

    if (!selectedFile) {
      setFile(null);
      return;
    }

    const fileType = selectedFile.type;
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    const maxFileSize = 50 * 1024 * 1024; // 50 MB in bytes

    if (
      !allowedTypes.includes(fileType) &&
      !allowedExtensions.includes(fileExtension)
    ) {
      setError(
        "Invalid file type. Please upload a CSV or Excel (.xls or .xlsx) file."
      );
      setFile(null);
    } else if (selectedFile.size > maxFileSize) {
      setError(
        "File size exceeds the 50 MB limit. Please upload a smaller file."
      );
      setFile(null);
    } else {
      setFile(selectedFile);
    }
  };

  const handleFileUpload = () => {
    // Trigger file input click
    fileInputRef.current?.click();
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  const handleConfirmUpload = async () => {
    if (!file) {
      setError("No file selected.");
      return;
    }
    const token = sessionStorage.getItem("token");

    const formData = new FormData();

    const operations = JSON.stringify({
      query: `
        mutation Upload($file: Upload!) {
          uploadCandidates(file: $file) {
            success
            error
            message
          }
        }
      `,
      variables: { file: null },
    });

    const map = JSON.stringify({
      0: ["variables.file"],
    });

    formData.append("operations", operations);
    formData.append("map", map);
    formData.append("0", file);

    try {
      const response = await axios.post(`${BASE_URL}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.data.uploadCandidates.success == true) {
        setPopup({
          open: true,
          message: response.data.data.uploadCandidates.message,
          severity: "success",
        });
        reset();
        setDialogOpen(false);
        fetchuploadlist();
      } else {
        setPopup({
          open: true,
          message: response.data.data.uploadCandidates.message,
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Upload failed", err);
    }
  };

  const reset = () => {
    setOpenFileUpload(false);
    setFile(null);
    setSelectedRows([]);
  };

  const handleFilechoose = () => {
    setOpenFileUpload(true);
  };
  const canceluplaod = () => {
    setOpenFileUpload(false);
    handleRemoveFile();
  };

  const canceluplaodpopup = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  const confirmupload = () => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to upload this record ?",
      onConfirm: () => handleConfirmUpload(),
      onClose: () => canceluplaodpopup(),
    });
  };

  const deletelist = () => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async () => {
    try {
      const variables = {
        input: {
          ids: selectedRows,
        },
      };
      const response = await deleteItem(deletebulkdata, variables);
      if (response.deleteCandidate.success == true) {
        setPopup({
          open: true,
          message: response.deleteCandidate.message,
          severity: "success",
        });
        deletecancel();
        fetchuploadlist();
      } else {
        setPopup({
          open: true,
          message: response.deleteCandidate.message,
          severity: "error",
        });
        deletecancel();
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  return (
    <DashboardLayout searchdata={searchdata} setsearchdata={setsearchdata}>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="Bulk Candidate Upload" action="Upload">
          <MaterialButton
            variant="contained"
            onClick={handleFilechoose}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 10.3333V13.4444C15 13.857 14.8361 14.2527 14.5444 14.5444C14.2527 14.8361 13.857 15 13.4444 15H2.55556C2.143 15 1.74733 14.8361 1.45561 14.5444C1.16389 14.2527 1 13.857 1 13.4444V10.3333M11.8889 4.88889L8 1M8 1L4.11111 4.88889M8 1V10.3333"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span style={{ marginLeft: "10px" }}>Bulk Upload</span>
          </MaterialButton>
        </AccessComponent>
        <AccessComponent name="Bulk Candidate Upload" action="Delete">
          {/* {selectedRows.length > 0 && ( */}
          <IconButton disabled={selectedRows.length === 0 ? true : false}>
            <DeleteIcon onClick={deletelist} />
          </IconButton>
          {/* )} */}
        </AccessComponent>
        <Dialog
          open={openfileupload}
          sx={{
            "& .MuiDialog-paper": {
              width: "500px",
              maxWidth: "none",
              height: "300px",
            },
          }}
        >
          <IconButton
            onClick={canceluplaod}
            sx={{ justifyContent: "end", display: "flex" }}
          >
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
          <DialogTitle sx={{ textAlign: "center", fontSize: 20 }}>
            Upload Excel/CSV File
          </DialogTitle>
          <DialogContent>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
              mt={1}
            >

              <Box
                sx={{
                  border: "1px dashed #C4C4C4",
                  borderRadius: "8px",
                  padding: "16px",
                  textAlign: "center",
                  backgroundColor: "#FAFAFA",
                  cursor: "pointer",
                }}
                onClick={handleFileUpload}
              >
                {!file ? (
                  <>
                    <Typography
                      variant="body1"
                      sx={{
                        cursor: "pointer",
                        color: "#130175",
                        fontSize: "14px",
                      }}
                    >
                      <span style={{ marginBottom: "-8px" }}>
                        <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.66663 12.2523L9.99996 8.91895M9.99996 8.91895L13.3333 12.2523M9.99996 8.91895V16.4189M16.6666 12.8713C17.6845 12.0307 18.3333 10.7589 18.3333 9.33561C18.3333 6.80431 16.2813 4.75228 13.75 4.75228C13.5679 4.75228 13.3975 4.65728 13.3051 4.50039C12.2183 2.65631 10.212 1.41895 7.91663 1.41895C4.46485 1.41895 1.66663 4.21717 1.66663 7.66895C1.66663 9.3907 2.36283 10.9498 3.48908 12.0802"
                            stroke="#535862"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>{" "}
                      <strong>Click to upload</strong> or drag and drop
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "14px" }}
                      color="textSecondary"
                    >
                      .csv,.xls,.xlsx (max. 50 MB )
                    </Typography>
                    <input
                      type="file"
                      hidden
                      accept=".csv,.xls,.xlsx"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                  </>
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    <Typography variant="body2">
                      <strong>Selected:</strong> {file.name}
                    </Typography>
                    <IconButton
                      onClick={handleRemoveFile}
                      color="error"
                      size="small"
                      aria-label="Remove File"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
                {error && <Typography color="error">{error}</Typography>}
              </Box>
              <Box display="flex" justifyContent="space-around" mt={3} gap={2}>
                <Button
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={confirmupload}
                  disabled={!file}
                >
                  Submit
                </Button>
                <MaterialButton
                  onClick={canceluplaod}
                  variant="outlined"
                  color="error"
                >
                  Cancel
                </MaterialButton>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        name="Bulk Candidate Upload"
        serverPage={page}
        totalCount={totalCount}
        rowsPerPage={pageSize}
        onPageChange={(event, newPage) => setPage(newPage)}
        ischeck={true}
      />
    </DashboardLayout>
  );
}

export default BulkuploadCandidate;
